<script>
import { RecyclingFolder } from '@/models/recyclingModule/recyclingFolder/RecyclingFolder'
import {
  displayToast,
  handleResponseError,
  shouldShowTooltip
} from '@/components/utils/globalFunction'
import ManufacturerService from '@/services/referentiel/ManufacturerService'
import RecyclingFolderService from '@/services/recyclingModule/RecyclingFolderService'
import RecyclingReferentialService from '@/services/recyclingModule/RecyclingReferentialService'
import AddAttachmentQRCodeModal from '@/components/recycling-module/acquisition/add-attachment/AddAttachmentQRCodeModal.vue'
import AddAttachmentPCModal from '@/components/recycling-module/acquisition/add-attachment/AddAttachmentPCModal.vue'
import { auth as $store } from '@/store/AuthModule'

export default {
  name: 'StepProductChecking',
  components: { AddAttachmentPCModal, AddAttachmentQRCodeModal },
  props: {
    currentStep: Number,
    currentRecyclingFolder: {
      type: RecyclingFolder,
      default: null
    }
  },
  data() {
    return {
      loading: false,
      formStepProductCheckingValid: false,
      dataLoaded: false,

      manufacturer: null,

      bacDetail: null,

      cguAgreement: false,

      buybackClientPart: 0,
      buybackStorePart: 0,

      error: null
    }
  },
  async created() {
    await this.getManufacturerByBoomerangId()

    if (!this.currentRecyclingFolder.buybackDetail.isRecycler) {
      await this.getBacDetail()
    }

    this.buybackClientPart = this.currentRecyclingFolder.buybackDetail.buybackClientPart
    this.buybackStorePart = this.currentRecyclingFolder.buybackDetail.buybackStorePart

    this.dataLoaded = true
  },
  watch: {
    buybackClientPart() {
      this.buybackStorePart =
        this.currentRecyclingFolder.buybackDetail.buybackPrice - this.buybackClientPart
    },
    buybackStorePart() {
      this.buybackClientPart =
        this.currentRecyclingFolder.buybackDetail.buybackPrice - this.buybackStorePart
    }
  },
  methods: {
    shouldShowTooltip,
    async submit() {
      await this.goToProductPackaging()
    },
    async getManufacturerByBoomerangId() {
      this.loading = true

      try {
        this.manufacturer = await ManufacturerService.getManufacturerByBoomerangId(
          this.currentRecyclingFolder.manufacturerBoomerangId
        )
      } catch (error) {
        handleResponseError(error)
      } finally {
        this.loading = false
      }
    },
    async getBacDetail() {
      this.loading = true

      try {
        this.bacDetail = await RecyclingReferentialService.getBacDetail(
          this.currentRecyclingFolder.boomerangId
        )
      } catch (error) {
        handleResponseError(error)
      } finally {
        this.loading = false
      }
    },
    async goToProductPackaging() {
      this.error = null
      this.loading = true
      try {
        const data = {
          buybackClientPart: this.buybackClientPart,
          buybackStorePart: this.buybackStorePart
        }

        await RecyclingFolderService.updateRecyclingFolderProductChecking(
          this.currentRecyclingFolder.boomerangId,
          data
        )

        this.$emit('change-step', this.currentStep + 1)
      } catch (error) {
        handleResponseError(error)
      } finally {
        this.loading = false
      }
    },
    async removeAttachment(attachmentTechnicalId) {
      this.loading = true
      const recyclingFolderBoomerangId = this.currentRecyclingFolder.boomerangId
      try {
        const data = {
          recyclingFolderBoomerangId: recyclingFolderBoomerangId,
          attachmentTechnicalId: attachmentTechnicalId,
          requesterCollaboratorId: $store.state.currentCollaborator.technical_id
        }

        await RecyclingFolderService.removeAttachmentFromRecyclingFolder(data)
        displayToast(
          this.$t(
            'RECYCLING_MODULE.STEP_PRODUCT_CHECKING.RECONDITIONER.ADD_ATTACHMENT.REMOVE_SUCCESS'
          ),
          'success'
        )
        this.$emit('refresh-recycling-folder')
      } catch (error) {
        handleResponseError(error)
      } finally {
        this.loading = false
      }
    },
    async openQrCodeAttachmentModal() {
      const response = await this.$refs.addAttachmentByQRCodeModal.show({
        currentRecyclingFolder: this.currentRecyclingFolder
      })

      if (response.confirmed) {
        this.$emit('refresh-recycling-folder')
      }
    },
    async openPcAttachmentModal() {
      const response = await this.$refs.addAttachmentByPCModal.show({
        currentRecyclingFolder: this.currentRecyclingFolder
      })

      if (response.confirmed) {
        this.$emit('refresh-recycling-folder')
      }
    }
  }
}
</script>

<template>
  <v-row class="step-container" v-if="dataLoaded">
    <!--RECYCLER CASE-->
    <v-col cols="7" v-if="currentRecyclingFolder.buybackDetail.isRecycler">
      <v-card class="step-card rounded-xl mt-4 d-flex-column" :border="false" :elevation="0">
        <v-row>
          <v-col>
            <h1 class="bold">{{ $t('RECYCLING_MODULE.STEP_PRODUCT_CHECKING.RECYCLER.TITLE') }}</h1>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <p class="bold">{{ $t('RECYCLING_MODULE.STEP_PRODUCT_CHECKING.RECYCLER.SUB_1') }}</p>
            <p class="bold">{{ $t('RECYCLING_MODULE.STEP_PRODUCT_CHECKING.RECYCLER.SUB_2') }}</p>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <p>{{ $t('RECYCLING_MODULE.STEP_PRODUCT_CHECKING.RECYCLER.TEXT_1') }}</p>
            <p>{{ $t('RECYCLING_MODULE.STEP_PRODUCT_CHECKING.RECYCLER.TEXT_2') }}</p>
          </v-col>
        </v-row>

        <v-row>
          <v-col class="bold">
            {{ $t('RECYCLING_MODULE.STEP_PRODUCT_CHECKING.RECYCLER.TEXT_3') }}
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" class="d-flex justify-start">
            <v-btn
              :disabled="loading"
              :loading="loading"
              class="pl-15 pr-15"
              :class="loading ? 'boom-button-transparent' : 'boom-button'"
              @click="goToProductPackaging()"
              variant="outlined"
            >
              {{ $t('COMMON.BUTTON.CONTINUE') }}
              <img
                alt="arrow_small-icon"
                :class="loading ? 'arrow-black-svg' : 'arrow-white-svg'"
                src="@/assets/icons/file/arrow_small_right.svg"
              />
            </v-btn>
          </v-col>
        </v-row>
      </v-card>
    </v-col>

    <!-- RECONDITIONER CASE -->
    <v-col cols="7" v-if="!currentRecyclingFolder.buybackDetail.isRecycler">
      <v-card class="step-card rounded-xl mt-4 d-flex-column" :border="false" :elevation="0">
        <v-form
          ref="formStepProductChecking"
          v-model="formStepProductCheckingValid"
          @submit.prevent="submit"
        >
          <!--TITLE-->
          <v-row>
            <v-col>
              <h1 class="bold">
                {{ $t('RECYCLING_MODULE.STEP_PRODUCT_CHECKING.RECONDITIONER.TITLE') }}
              </h1>
            </v-col>
          </v-row>

          <!--SUBTITLE-->
          <v-row>
            <v-col>
              <p class="bold">
                {{ $t('RECYCLING_MODULE.STEP_PRODUCT_CHECKING.RECONDITIONER.SUB_1') }}
              </p>
            </v-col>
          </v-row>

          <!--DESCRIPTION TEXT-->
          <v-row>
            <v-col>
              <p>{{ $t('RECYCLING_MODULE.STEP_PRODUCT_CHECKING.RECONDITIONER.TEXT_1') }}</p>
              <p>{{ $t('RECYCLING_MODULE.STEP_PRODUCT_CHECKING.RECONDITIONER.TEXT_2') }}</p>
              <p>{{ $t('RECYCLING_MODULE.STEP_PRODUCT_CHECKING.RECONDITIONER.TEXT_3') }}</p>
            </v-col>
          </v-row>

          <!--EXAMPLE PICTURE-->
          <v-row v-if="bacDetail?.pictureQrCodeUrl">
            <v-col>
              <v-img
                class="picture-example"
                :src="bacDetail?.pictureQrCodeUrl"
                alt="Product picture example"
              />
            </v-col>
          </v-row>

          <!--ADD ATTACHMENT-->
          <v-row>
            <v-col cols="12">
              <v-row>
                <v-col cols="12" md="6">
                  <v-text-field
                    :label="
                      $t(
                        'RECYCLING_MODULE.STEP_PRODUCT_CHECKING.RECONDITIONER.ADD_ATTACHMENT.INPUT_LABEL_BY_QR_CODE'
                      )
                    "
                    :disabled="currentRecyclingFolder.attachmentList.length >= 2"
                    :hide-details="!error?.attachmentList"
                    append-inner-icon="mdi-camera"
                    @click="openQrCodeAttachmentModal()"
                  />
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    :label="
                      $t(
                        'RECYCLING_MODULE.STEP_PRODUCT_CHECKING.RECONDITIONER.ADD_ATTACHMENT.INPUT_LABEL_BY_PC'
                      )
                    "
                    :disabled="currentRecyclingFolder.attachmentList.length >= 2"
                    :hide-details="!error?.attachmentList"
                    append-inner-icon="mdi-download"
                    @click="openPcAttachmentModal()"
                  />
                </v-col>
              </v-row>
              <v-row
                class="chip-container pb-3"
                v-if="currentRecyclingFolder.attachmentList.length > 0"
              >
                <v-col
                  v-for="attachment of currentRecyclingFolder.attachmentList"
                  :key="attachment.technicalId"
                  class="attachment-file-chip"
                >
                  <v-chip append-icon="mdi-close" class="clickable-chip">
                    {{
                      $t(
                        'RECYCLING_MODULE.STEP_PRODUCT_CHECKING.RECONDITIONER.ADD_ATTACHMENT.PICTURE_NAME_LABEL'
                      )
                    }}{{ attachment.attachmentCounter }}
                    <template v-slot:append>
                      <v-icon @click="removeAttachment(attachment.technicalId)" class="append-icon">
                        mdi-close
                      </v-icon>
                    </template>
                  </v-chip>
                </v-col>
              </v-row>
            </v-col>
          </v-row>

          <!-- CGU -->
          <v-row>
            <v-col>
              <v-checkbox
                density="compact"
                hide-details
                v-model="cguAgreement"
                required
                :label="$t('RECYCLING_MODULE.STEP_PRODUCT_CHECKING.RECONDITIONER.CGU_LABEL')"
                color="#559a1b"
              />
            </v-col>
          </v-row>

          <!-- Validation form Button -->
          <v-row>
            <v-col cols="12" class="d-flex justify-start">
              <v-btn
                :disabled="
                  !formStepProductCheckingValid ||
                  currentRecyclingFolder.attachmentList.length !== 2 ||
                  cguAgreement === false ||
                  loading
                "
                :loading="loading"
                class="pl-15 pr-15"
                :class="
                  !formStepProductCheckingValid ||
                  currentRecyclingFolder.attachmentList.length !== 2 ||
                  cguAgreement === false ||
                  loading
                    ? 'boom-button-transparent'
                    : 'boom-button'
                "
                type="submit"
                variant="outlined"
              >
                {{ $t('COMMON.BUTTON.CONTINUE') }}
                <img
                  alt="arrow_small-icon"
                  :class="
                    !formStepProductCheckingValid ||
                    currentRecyclingFolder.attachmentList.length !== 2 ||
                    cguAgreement === false ||
                    loading
                      ? 'arrow-black-svg'
                      : 'arrow-white-svg'
                  "
                  src="@/assets/icons/file/arrow_small_right.svg"
                />
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-card>
    </v-col>

    <!--PICTURE CARD-->
    <v-col cols="5">
      <v-card class="step-card rounded-xl mt-4 d-flex-column" :border="false" :elevation="0">
        <v-card
          class="product-card"
          :ripple="false"
          :id="currentRecyclingFolder.productDetail.technicalId"
        >
          <div class="picture" v-if="currentRecyclingFolder.productDetail.picture">
            <v-img
              class="picture-content"
              :src="currentRecyclingFolder.productDetail.picture"
              alt="Product Preview"
            />
          </div>

          <v-card-text>
            <v-row
              align="center"
              class="mx-0 flex-fill d-flex align-center justify-center flex-column"
            >
              <v-col class="d-flex align-center justify-center flex-column">
                <p class="manufacturer-name">
                  {{ manufacturer?.name }}
                </p>
              </v-col>
              <v-col class="d-flex align-center justify-center flex-column">
                <p class="product-name">
                  {{ currentRecyclingFolder.productDetail.boomerangName }}
                </p>
              </v-col>

              <v-col>
                <v-divider />
              </v-col>

              <v-col class="d-flex justify-center flex-column">
                <v-row>
                  <v-col cols="6">
                    {{ $t('RECYCLING_MODULE.STEP_PRODUCT_CHECKING.CONDITION_LABEL') }}
                  </v-col>
                  <v-col cols="6" class="condition-title-col">
                    {{ currentRecyclingFolder.buybackDetail.conditionTitle }}
                  </v-col>
                </v-row>
              </v-col>

              <v-col>
                <v-divider />
              </v-col>

              <v-col>
                <v-row>
                  <v-col cols="6" class="d-flex justify-center flex-column">
                    {{ $t('RECYCLING_MODULE.STEP_PRODUCT_CHECKING.BUYBACK_PRICE_LABEL') }}
                  </v-col>
                  <v-col cols="6" class="condition-price-col">
                    {{ currentRecyclingFolder.buybackDetail.buybackPrice }} €
                  </v-col>
                </v-row>
              </v-col>

              <v-col>
                <v-divider />
              </v-col>

              <v-col>
                <v-row>
                  <v-col cols="6" class="d-flex flex-row">
                    <v-row>
                      <v-col cols="9" class="d-flex align-center">
                        {{
                          $t('RECYCLING_MODULE.STEP_PRODUCT_CHECKING.BUYBACK_PRICE_CLIENT_LABEL')
                        }}
                      </v-col>
                      <v-col cols="3" class="d-flex buyback-input">
                        <v-text-field
                          v-model="buybackClientPart"
                          type="number"
                          min="0"
                          :max="
                            currentRecyclingFolder.buybackDetail.buybackPrice - buybackStorePart
                          "
                          step="1.00"
                          hide-details
                          append-inner-icon="mdi-currency-eur"
                        />
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="6" class="d-flex flex-row">
                    <v-row>
                      <v-col cols="9" class="d-flex align-center">
                        {{ $t('RECYCLING_MODULE.STEP_PRODUCT_CHECKING.BUYBACK_PRICE_STORE_LABEL') }}
                      </v-col>
                      <v-col cols="3" class="d-flex buyback-input">
                        <v-text-field
                          v-model="buybackStorePart"
                          type="number"
                          min="0"
                          :max="
                            currentRecyclingFolder.buybackDetail.buybackPrice - buybackClientPart
                          "
                          step="1.00"
                          hide-details
                          append-inner-icon="mdi-currency-eur"
                        />
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-card>
    </v-col>
  </v-row>
  <AddAttachmentQRCodeModal ref="addAttachmentByQRCodeModal" />
  <AddAttachmentPCModal ref="addAttachmentByPCModal" />
</template>

<style scoped>
.step-container {
  min-height: 70vh;

  .step-card {
    padding: 24px;
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;

    .bold {
      font-weight: bold;
    }

    .product-card {
      background-color: #efefef;
      padding: 24px;
      box-shadow: none;
      border-radius: 24px;

      .manufacturer-name {
        font-size: 18px;
        font-weight: bold;
        color: #559a1b;
      }

      .product-name {
        font-size: 18px;
        font-weight: bold;
      }

      .picture .picture-content {
        max-width: 350px;
        max-height: 350px;
      }

      .picture {
        margin: auto;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 10px;
        background: white;
        padding: 10px;
      }

      .condition-title-col,
      .condition-price-col {
        font-weight: bold;
        text-align: end;
      }

      .condition-price-col {
        font-size: x-large;
      }
    }

    .arrow-black-svg {
      height: 100%;
      width: 50%;
      filter: invert(0%) sepia(35%) saturate(13%) hue-rotate(154deg) brightness(96%) contrast(100%);
    }

    .arrow-white-svg {
      height: 100%;
      width: 50%;
      filter: invert(100%) sepia(0%) saturate(1%) hue-rotate(209deg) brightness(109%) contrast(101%);
    }

    .boom-button-transparent:hover .arrow-svg {
      filter: invert(48%) sepia(35%) saturate(7492%) hue-rotate(64deg) brightness(105%)
        contrast(79%);
    }

    .picture-example {
      max-height: 200px;
      margin: auto;
    }

    .attachment-file-chip {
      padding: 1px;
      max-width: 125px;
    }

    :deep(.clickable-chip .v-chip__append) {
      cursor: pointer;
    }

    .chip-container {
      margin-left: 0;
    }

    .buyback-input {
      min-width: 120px;
    }
  }
}
</style>
